// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1-WDA","noInteraction":"EventWrapper_noInteraction__2rxV-","pointerPassthrough":"EventWrapper_pointerPassthrough__2qhPN"};